// AUTO-GENERATED from DRS 2026 Scientific Program sheet + CV deck. Do not edit by hand.
export const programData = [
 {
  "day": "Day 1",
  "date": "4th September, 2026 (Friday)",
  "halls": [
   {
    "hall": "DRS HALL",
    "items": [
     {
      "kind": "break",
      "time": "12:30PM Onwards",
      "label": "Registration & Lunch"
     },
     {
      "kind": "session",
      "title": "Lamp Lighting & Inauguration",
      "time": "01:30PM - 02:00PM",
      "people": [],
      "talks": [],
      "type": "Ceremony"
     },
     {
      "kind": "session",
      "title": "The DiabetesIndia Symposium",
      "time": "02:30PM - 03:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "photo": "/faculty/f_banshi_saboo.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Priyanka Rasne",
        "city": "Pune",
        "photo": "/faculty/f_priyanka_rasne.jpg"
       }
      ],
      "talks": [
       {
        "time": "02:30PM - 02:45PM",
        "title": "Beyond Numbers- Decoding Diabetes Distress",
        "speaker": "Dr. Mayur Agrawal",
        "city": "Bhopal",
        "group": null,
        "photo": "/faculty/f_mayur_agrawal.jpg"
       },
       {
        "time": "02:45PM - 03:00PM",
        "title": "GLP-1 RAs in Non-Obese T2DM",
        "speaker": "Dr. Sanjay Reddy",
        "city": "Bengaluru",
        "group": null,
        "photo": "/faculty/f_sanjay_reddy.jpg"
       },
       {
        "time": "03:00PM - 03:20PM",
        "title": "Resmetirom: The First Liver Targeted Therapy for MASH",
        "speaker": "Dr. Akash Shukla",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "03:20PM - 03:30PM",
        "title": "Panel Discussion - All speakers",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Symposium"
     },
     {
      "kind": "session",
      "title": "The DRS PSG Symposium",
      "time": "03:30PM - 04:45PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Anuj Maheshwari",
        "city": "Lucknow",
        "photo": "/faculty/f_anuj_maheshwari.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. A. Bhavatharini",
        "city": "Erode",
        "photo": "/faculty/f_a_bhavatharini.jpg"
       }
      ],
      "talks": [
       {
        "time": "03:30PM - 03:55PM",
        "title": "The Burning Question 1: OHAs in Pregnancy",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "03:30PM - 03:40PM",
        "title": "Yes",
        "speaker": "Dr. Uday Thanawala",
        "city": "Mumbai",
        "group": "The Burning Question 1: OHAs in Pregnancy",
        "photo": "/faculty/f_uday_thanawala.jpg"
       },
       {
        "time": "03:40PM - 03:50PM",
        "title": "No",
        "speaker": "Dr. Shalini Jaggi",
        "city": "New Delhi",
        "group": "The Burning Question 1: OHAs in Pregnancy",
        "photo": "/faculty/f_shalini_jaggi.jpg"
       },
       {
        "time": "03:50PM - 03:55PM",
        "title": "Rebuttal",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "03:55PM - 04:10PM",
        "title": "Hypoglycemia in Pregnancy",
        "speaker": "Dr. Mayura Kale",
        "city": "Aurangabad",
        "group": "Rebuttal",
        "photo": "/faculty/f_mayura_kale.jpg"
       },
       {
        "time": "04:10PM - 04:25PM",
        "title": "Diet in Pregnancy: Myths / Evidence & Gen Z Diets",
        "speaker": "Dt. Sheryl Salis",
        "city": "Mumbai",
        "group": "Rebuttal",
        "photo": "/faculty/f_sheryl_salis.jpg"
       },
       {
        "time": "04:25PM - 04:40PM",
        "title": "FEMTECH: Technology Assisted HIP Management",
        "speaker": "Dr. Rutul Gokalani",
        "city": "Ahmedabad",
        "group": "Rebuttal",
        "photo": "/faculty/f_rutul_gokalani.jpg"
       },
       {
        "time": "04:40PM - 04:45PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Symposium"
     },
     {
      "kind": "session",
      "title": "Continuous Glucose Monitoring, India Roadmap Ahead",
      "time": "04:45PM - 06:00PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "photo": "/faculty/f_banshi_saboo.jpg"
       }
      ],
      "talks": [
       {
        "time": "04:45PM - 04:50PM",
        "title": "Introduction of the Panel and Chair",
        "speaker": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_banshi_saboo.jpg"
       },
       {
        "time": "04:50PM - 05:05PM",
        "title": "India Landscape of CGM Adoption, Do We Really Need It?",
        "speaker": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_banshi_saboo.jpg"
       },
       {
        "time": "05:05PM - 05:20PM",
        "title": "How Can CGM Improve Control?",
        "speaker": "Dr. Manoj Chawla",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_manoj_chawla.jpg"
       },
       {
        "time": "05:20PM - 05:40PM",
        "title": "My Experience in Practice with CGM",
        "speaker": "Dr. Sueziani Binte Zainudin",
        "city": "Singapore",
        "group": null,
        "photo": "/faculty/f_sueziani_binte_zainudin.jpg"
       },
       {
        "time": "05:40PM - 05:55PM",
        "title": "Panel Discussion: How do we Improve Patient Compliance?",
        "speaker": "Dr. Purvi Chawla",
        "city": "Mumbai",
        "group": null,
        "cospeakers": [
         {
          "name": "Dr. R. M. Anjana",
          "city": "Chennai",
          "photo": "/faculty/f_r_m_anjana.jpg"
         },
         {
          "name": "Dr. Nanditha R",
          "city": "Chennai",
          "photo": "/faculty/f_nanditha_r.jpg"
         }
        ],
        "photo": "/faculty/f_purvi_chawla.jpg"
       },
       {
        "time": "05:55PM - 06:00PM",
        "title": "Q&A and Closing",
        "speaker": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_banshi_saboo.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Emerging Concepts",
      "time": "06:00PM - 06.45PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Pratiksha Patil",
        "city": "Mumbai",
        "photo": "/faculty/f_pratiksha_patil.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Chand Patel",
        "city": "Mumbai",
        "photo": "/faculty/f_chand_patel.jpg"
       }
      ],
      "talks": [
       {
        "time": "06:00PM - 06:20PM",
        "title": "Fatty Pancreas- As Dangerous as Fatty Liver ?",
        "speaker": "Dr. Ranjit Unnikrishnan",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_ranjit_unnikrishnan.jpg"
       },
       {
        "time": "06:20PM - 06:40PM",
        "title": "Chronodiabetology- The Role of Circadian Rhythm in Diabetes",
        "speaker": "Dr. Arvind Gupta",
        "city": "Jaipur",
        "group": null,
        "photo": "/faculty/f_arvind_gupta.jpg"
       },
       {
        "time": "06:40PM - 06:45PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "The GLP Revolution: Innovator Semaglutide Leading the Pack",
      "time": "06:45PM - 07:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Aniruddh Makhecha",
        "city": "Mumbai",
        "photo": "/faculty/f_aniruddh_makhecha.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Rohini Gajare",
        "city": "Mumbai",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "06:45PM - 07:05PM",
        "title": "From Molecule to Meaningful Outcomes: The Expanding Role of Oral Semaglutide",
        "speaker": "Dr. Lakshmi Nagendra",
        "city": "Mysuru",
        "group": null,
        "photo": "/faculty/f_lakshmi_nagendra.jpg"
       },
       {
        "time": "07:05PM - 07:25PM",
        "title": "Quality by Design: The Innovator Semaglutide Advantage",
        "speaker": "Dr. A. K. Singh",
        "city": "Kolkata",
        "group": null,
        "photo": "/faculty/f_a_k_singh.jpg"
       },
       {
        "time": "07:25PM - 07:30PM",
        "title": "Q&A Discussions",
        "speaker": "Dr. Lakshmi Nagendra",
        "city": "Mysuru",
        "group": null,
        "cospeakers": [
         {
          "name": "Dr. A. K. Singh",
          "city": "Kolkata",
          "photo": "/faculty/f_a_k_singh.jpg"
         }
        ],
        "photo": "/faculty/f_lakshmi_nagendra.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Acute to Chronic Symposium",
      "time": "07:30PM - 08:45PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Chandrashekhar Ashtekar",
        "city": "Latur",
        "photo": "/faculty/f_chandrashekhar_ashtekar.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Alok Modi",
        "city": "Mumbai",
        "photo": "/faculty/f_alok_modi.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Kandula Sai",
        "city": "Rajahmundry",
        "photo": "/faculty/f_kandula_sai.jpg"
       }
      ],
      "talks": [
       {
        "time": "07:30PM - 07:35PM",
        "title": "Context Setting",
        "speaker": "Dr. Chandrashekhar Ashtekar",
        "city": "Latur",
        "group": null,
        "photo": "/faculty/f_chandrashekhar_ashtekar.jpg"
       },
       {
        "time": "07:35PM - 07:50PM",
        "title": "Basics of Sick Day Hyperglycemia Management for T2DM",
        "speaker": "Dr. Narsingh Verma",
        "city": "Lucknow",
        "group": null,
        "photo": "/faculty/f_narsingh_verma.jpg"
       },
       {
        "time": "07:50PM - 08:05PM",
        "title": "Embarrassing Prescriptions - Let's Avoid These",
        "speaker": "Dr. A. K. Singh",
        "city": "Kolkata",
        "group": null,
        "photo": "/faculty/f_a_k_singh.jpg"
       },
       {
        "time": "08:05PM - 08:20PM",
        "title": "Algorithm of OHA Use Made Simpler for Drug Naive T2DM",
        "speaker": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_banshi_saboo.jpg"
       },
       {
        "time": "08:20PM - 08:35PM",
        "title": "Mastering the ART of Using Injectables in T2DM",
        "speaker": "Dr. Jayant Panda",
        "city": "Cuttack",
        "group": null,
        "photo": "/faculty/f_jayant_panda.jpg"
       },
       {
        "time": "08:35PM - 08:45PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Symposium"
     },
     {
      "kind": "break",
      "time": "08:45PM - 10:30PM",
      "label": "Dinner"
     }
    ],
    "sessionCount": 7
   },
   {
    "hall": "IDF HALL",
    "items": [
     {
      "kind": "break",
      "time": "12:30PM Onwards",
      "label": "Registration & Lunch"
     },
     {
      "kind": "session",
      "title": "Opening Plenary",
      "time": "02:00PM - 02:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Noor Al Busaidi",
        "city": "Oman",
        "photo": "/faculty/f_noor_al_busaidi.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Lalantha Leelarathna",
        "city": "UK",
        "photo": "/faculty/f_lalantha_leelarathna.jpg"
       }
      ],
      "talks": [
       {
        "time": "02:00PM - 02:30PM",
        "title": "Pharmacotherapy in Diabetes: Translating Latest Guidelines into Clinical Practice",
        "speaker": "Prof. Peter Schwarz",
        "city": "Germany",
        "group": null,
        "photo": "/faculty/f_peter_schwarz.jpg"
       }
      ],
      "type": "Plenary"
     },
     {
      "kind": "session",
      "title": "Preventing Blindness in Diabetes (Theme: From Early Detection to Vision Preservation)",
      "time": "02:30PM - 03:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Shamin Karbhari",
        "city": "Mumbai",
        "photo": "/faculty/f_shamin_karbhari.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Aarti Ullal",
        "city": "Mumbai",
        "photo": "/faculty/f_aarti_ullal.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Vishesh Agarwal",
        "city": "Mumbai",
        "photo": "/faculty/f_vishesh_agarwal.jpg"
       }
      ],
      "talks": [
       {
        "time": "02:30PM - 02:35PM",
        "title": "Context Setting",
        "speaker": "Dr. Shamin Karbhari",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_shamin_karbhari.jpg"
       },
       {
        "time": "02:35PM - 02:50PM",
        "title": "Managing Diabetic Macular Edema in 2026",
        "speaker": "Dr. Saumil Sheth",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "02:50PM - 03:10PM",
        "title": "Beyond the Retina: AI, Tele-Screening and Home-Based Retinal Imaging\nHow Technology is Transforming Diabetic Eye Care?",
        "speaker": "Dr. R. M. Anjana",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_r_m_anjana.jpg"
       },
       {
        "time": "03:10PM - 03:25PM",
        "title": "Diabetic Retinopathy: Can we Prevent it Before it Starts?\nRisk Prediction, Screening Intervals and Early Intervention",
        "speaker": "Dr. Kiran Shah",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_kiran_shah.jpg"
       },
       {
        "time": "03:25PM - 03:30PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Preventing DKD & ESKD (Theme: Preserving Kidney Function for Life)",
      "time": "03:30PM - 04:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Keyur Dave",
        "city": "Mumbai",
        "photo": "/faculty/f_keyur_dave.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Sanjay Bhatt",
        "city": "Rajkot",
        "photo": "/faculty/f_sanjay_bhatt.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Priti Sanghavi",
        "city": "Mumbai",
        "photo": "/faculty/f_priti_sanghavi.jpg"
       }
      ],
      "talks": [
       {
        "time": "03:30PM - 03:35PM",
        "title": "Context Setting",
        "speaker": "Dr. Keyur Dave",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_keyur_dave.jpg"
       },
       {
        "time": "03:35PM - 03:50PM",
        "title": "The New Era of Early DKD Detection\nAlbuminuria, eGFR, Biomarkers and Imaging",
        "speaker": "Dr. Ajoy Tewari",
        "city": "Lucknow",
        "group": null,
        "photo": "/faculty/f_ajoy_tewari.jpg"
       },
       {
        "time": "03:50PM - 04:10PM",
        "title": "Management of DKD in 2026: A Pillar Based Approach",
        "speaker": "Dr. Deodatta Chafekar",
        "city": "Nashik",
        "group": null,
        "photo": "/faculty/f_deodatta_chafekar.jpg"
       },
       {
        "time": "04:10PM - 04:25PM",
        "title": "Glycaemic Management in DKD Stage 3 & Beyond",
        "speaker": "Dr. Pratap Jethwani",
        "city": "Rajkot",
        "group": null,
        "photo": "/faculty/f_pratap_jethwani.jpg"
       },
       {
        "time": "04:25PM - 04:30PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Preventing Obesity Progression (Theme: Stopping Obesity Before Complications Develop)",
      "time": "04:30PM - 05:25PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Rikin Shah",
        "city": "Ahmedabad",
        "photo": "/faculty/f_rikin_shah.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Ashish Aneja",
        "city": "Kurukshetra",
        "photo": "/faculty/f_ashish_aneja.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Ms. Sunitha Jothydev",
        "city": "Thiruvananthapuram",
        "photo": "/faculty/f_sunitha_jothydev.jpg"
       }
      ],
      "talks": [
       {
        "time": "04:30PM - 04:35PM",
        "title": "Context Setting",
        "speaker": "Dr. Rikin Shah",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_rikin_shah.jpg"
       },
       {
        "time": "04:35PM - 04:50PM",
        "title": "The Biology of Weight Gain: Why Obesity Progresses Appetite Regulation, Genetics and Environment",
        "speaker": "Dr. Lakshmi Nagendra",
        "city": "Mysuru",
        "group": null,
        "photo": "/faculty/f_lakshmi_nagendra.jpg"
       },
       {
        "time": "04:50PM - 05:05PM",
        "title": "Expanding  Semaglutide Access for Practitioners & Practical Insights",
        "speaker": "Dr. Nitin Patankar",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_nitin_patankar.jpg"
       },
       {
        "time": "05:05PM - 05:20PM",
        "title": "Muscle Matters: Achieving Fat Loss Without Losing Strength",
        "speaker": "Dr. Ketan Pakhale",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_ketan_pakhale.jpg"
       },
       {
        "time": "05:20PM - 05:25PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "The RSSDI Symposium",
      "time": "05:40PM - 07:15PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Rakesh Parikh",
        "city": "Jaipur",
        "photo": "/faculty/f_rakesh_parikh.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Lotika Purohit",
        "city": "Mumbai",
        "photo": "/faculty/f_lotika_purohit.jpg"
       }
      ],
      "talks": [
       {
        "time": "05:40PM - 06:00PM",
        "title": "Imeglimin: A Powerhouse Approach to T2DM",
        "speaker": "Dr. Anuj Maheshwari",
        "city": "Lucknow",
        "group": null,
        "photo": "/faculty/f_anuj_maheshwari.jpg"
       },
       {
        "time": "06:00PM - 06:20PM",
        "title": "From Packet to Pancreas: Ultra-Processed Food and Diabetes",
        "speaker": "Dr. Sanjiv Indurkar",
        "city": "Aurangabad",
        "group": null,
        "photo": "/faculty/f_sanjiv_indurkar.jpg"
       },
       {
        "time": "06:20PM - 06:40PM",
        "title": "Adherence to Outcomes- A Simple Diabetes Management Score",
        "speaker": "Dr. Rajesh Kesari",
        "city": "New Delhi",
        "group": null,
        "photo": "/faculty/f_rajesh_kesari.jpg"
       },
       {
        "time": "06:40PM - 07:00PM",
        "title": "Precision Medicine in GDM",
        "speaker": "Dr. A. Bhavatharini",
        "city": "Erode",
        "group": null,
        "photo": "/faculty/f_a_bhavatharini.jpg"
       },
       {
        "time": "07:00PM - 07:15PM",
        "title": "Redefining TZD Paradigm with Lobeglitazone",
        "speaker": "Dr. Shashank Joshi",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_shashank_joshi.jpg"
       }
      ],
      "type": "Symposium"
     },
     {
      "kind": "session",
      "title": "De-Intensification of Therapy in DM",
      "time": "07:15PM - 08:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Heena Goswami",
        "city": "Jamnagar",
        "photo": "/faculty/f_heena_goswami.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Dhruvi Hasnani",
        "city": "Ahmedabad",
        "photo": "/faculty/f_dhruvi_hasnani.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Thushan Gooneratne",
        "city": "Sri Lanka",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "07:15PM - 07:20PM",
        "title": "Context Setting",
        "speaker": "Dr. Heena Goswami",
        "city": "Jamnagar",
        "group": null,
        "photo": "/faculty/f_heena_goswami.jpg"
       },
       {
        "time": "07:20PM - 07:35PM",
        "title": "Overview & Case 1 - Initiating GLP/ GIP-GLP",
        "speaker": "Dr. Alpana Sowani",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_alpana_sowani.jpg"
       },
       {
        "time": "07:35PM - 07:50PM",
        "title": "Case 2-  Basal to Basal Plus/Basal Bolus - Handling the OHAs",
        "speaker": "Dr. Anchin Kalia",
        "city": "Jaipur",
        "group": null,
        "photo": "/faculty/f_anchin_kalia.jpg"
       },
       {
        "time": "07:50PM - 08:05PM",
        "title": "Case 3- Post Major Sx - Reintroduction of OHAs to Basal Bolus Therapy",
        "speaker": "Dr. Vipul Chavda",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_vipul_chavda.jpg"
       },
       {
        "time": "08:05PM - 08:20PM",
        "title": "Case 4- Worsening CKD - Starting Insulin & Deintensifying OHAs",
        "speaker": "Dr. Jimit Vadgama",
        "city": "Surat",
        "group": null,
        "photo": "/faculty/f_jimit_vadgama.jpg"
       },
       {
        "time": "08:20PM - 08:30PM",
        "title": "Discussion",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "break",
      "time": "08:30PM - 10:30PM",
      "label": "Dinner"
     },
     {
      "kind": "session",
      "title": "Digitalising Indian Healthcare- the RSSDI KCDD Projects",
      "time": "",
      "people": [],
      "talks": [
       {
        "time": "",
        "title": "KCDD",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     }
    ],
    "sessionCount": 7
   }
  ]
 },
 {
  "day": "Day 2",
  "date": "5th September, 2026 (Saturday)",
  "halls": [
   {
    "hall": "DRS HALL",
    "items": [
     {
      "kind": "break",
      "time": "08:00AM Onwards",
      "label": "Registration & Breakfast"
     },
     {
      "kind": "session",
      "title": "Oral Paper Presentations (07mins presentation + 02mins Discussion)",
      "time": "09:00AM - 10:00AM",
      "people": [
       {
        "role": "Judge",
        "name": "Dr. Anubha Varma",
        "city": "Prayagraj",
        "photo": "/faculty/f_anubha_varma.jpg"
       },
       {
        "role": "Judge",
        "name": "Dr. Girish Rajadhyaksha",
        "city": "Mumbai",
        "photo": "/faculty/f_girish_rajadhyaksha.jpg"
       }
      ],
      "talks": [
       {
        "time": "09:00AM - 09:09AM",
        "title": "Machine Learning-Based Analysis Of Gut Microbiome And Clinical Features For Type 1 Diabetes Prediction",
        "speaker": "Dr. Manish Agarwal",
        "city": "Ahmedabad",
        "group": null,
        "photo": null
       },
       {
        "time": "09:09AM - 09:18AM",
        "title": "Low Glycemic Index, Or Low Glycemic Load, Diets For Diabetes Mellitus",
        "speaker": "Dr. Manish Agarwal",
        "city": "Ahmedabad",
        "group": null,
        "photo": null
       },
       {
        "time": "09:18AM - 09:27AM",
        "title": "Lipid Testing in Atherosclerotic Cardiovascular Disease – Perceptions of Indian Clinicians",
        "speaker": "Dr. Amit Sharma",
        "city": "",
        "group": null,
        "photo": null
       },
       {
        "time": "09:27AM - 09:36AM",
        "title": "Beyond Weight Gain: Divergent Weight Trajectories in Breast Cancer Survivorship and Their Implications for Diabetes Management",
        "speaker": "Dr. Aastha Naik",
        "city": "vadodara",
        "group": null,
        "photo": null
       },
       {
        "time": "09:36AM - 09:45AM",
        "title": "A Cross-Sectional Study Of Pulmonary Function Tests In Patients With Type 1 Diabetes Mellitus",
        "speaker": "Dr. Bhushan Laddha",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "09:45AM - 09:54AM",
        "title": "A Decision-Support Framework For The Design And Evaluation Of Type 2 Diabetes Screening Interventions.",
        "speaker": "Dr. Catherine Akoth",
        "city": "UK",
        "group": null,
        "photo": null
       },
       {
        "time": "09:54AM – 10:00AM",
        "title": "Session wrap-up",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Papers"
     },
     {
      "kind": "session",
      "title": "DRS IDF Oration",
      "time": "10:00AM - 10:30AM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Prof. Peter Schwarz",
        "city": "Germany",
        "photo": "/faculty/f_peter_schwarz.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "photo": "/faculty/f_banshi_saboo.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Purvi Chawla",
        "city": "Mumbai",
        "photo": "/faculty/f_purvi_chawla.jpg"
       }
      ],
      "talks": [
       {
        "time": "10:00AM - 10:30AM",
        "title": "Menopause & Hormone Therapy in 2026",
        "speaker": "Dr. Usha Sriram",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_usha_sriram.jpg"
       }
      ],
      "type": "Oration"
     },
     {
      "kind": "session",
      "title": "The Burning Question 2: Drug Treatment of Prediabetes",
      "time": "10:30AM - 11:00AM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Sheetal Aversekar",
        "city": "Mumbai",
        "photo": "/faculty/f_sheetal_aversekar.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Sachin Mohite",
        "city": "Mumbai",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "10:30AM - 10:42AM",
        "title": "Yes",
        "speaker": "Dr. Dhruvi Hasnani",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_dhruvi_hasnani.jpg"
       },
       {
        "time": "10:43AM - 10:55AM",
        "title": "No",
        "speaker": "Dr. Shubhashree Patil",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_shubhashree_patil.jpg"
       },
       {
        "time": "10:55AM - 11:00AM",
        "title": "Rebuttal",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "GLP-1 Metabolic Symposium",
      "time": "11:00AM - 11:45AM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Rajesh Yadav",
        "city": "Mumbai",
        "photo": "/faculty/f_rajesh_yadav.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Prashant Bhalerao",
        "city": "Mumbai",
        "photo": "/faculty/f_prashant_bhalerao.jpg"
       }
      ],
      "talks": [
       {
        "time": "11:00AM - 11:20AM",
        "title": "Starting Smart: Semaglutide for Early Metabolic Benefits",
        "speaker": "Dr. Vijay Negalur",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_vijay_negalur.jpg"
       },
       {
        "time": "11:20AM - 11:40AM",
        "title": "The Big Picture in T2D: Comprehensive Holistic Care with Semaglutide",
        "speaker": "Dr. Shehla Shaikh",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_shehla_shaikh.jpg"
       },
       {
        "time": "11:40AM - 11:45AM",
        "title": "Q&A Discussions",
        "speaker": "Dr. Vijay Negalur",
        "city": "Mumbai",
        "group": null,
        "cospeakers": [
         {
          "name": "Dr. Shehla Shaikh",
          "city": "Mumbai",
          "photo": "/faculty/f_shehla_shaikh.jpg"
         }
        ],
        "photo": "/faculty/f_vijay_negalur.jpg"
       }
      ],
      "type": "Symposium"
     },
     {
      "kind": "session",
      "title": "Reframing Obesity Management, Multiorgan Risk and Incretin Therapies",
      "time": "11:45AM - 12:45PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Imran Hafizi",
        "city": "Mumbai",
        "photo": "/faculty/f_imran_hafizi.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Jenish Vira",
        "city": "Mumbai",
        "photo": "/faculty/f_jenish_vira.jpg"
       }
      ],
      "talks": [
       {
        "time": "11:45AM - 12:00PM",
        "title": "Obesity as a Chronic Disease: Beyond the BMI Paradigm",
        "speaker": "Dr. Vimal Pahuja",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_vimal_pahuja.jpg"
       },
       {
        "time": "12:00PM - 12:15PM",
        "title": "One Disease, Many Organs: The Silent Progression from Fat to Organ Dysfunction",
        "speaker": "Dr. Nanditha R",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_nanditha_r.jpg"
       },
       {
        "time": "12:15PM - 12:30PM",
        "title": "The Incretin Advances: Mono-Agonism to Dual-Agonism in Treatment of Obesity and its Clinical Implications",
        "speaker": "Dr. Mangesh Tiwaskar",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_mangesh_tiwaskar.jpg"
       },
       {
        "time": "12:30PM - 12:40PM",
        "title": "Putting it all Together: Integrating Evidence into Practice Followed by Concluding Remarks",
        "speaker": "Dr. Mathew John",
        "city": "Thiruvananthapuram",
        "group": null,
        "photo": "/faculty/f_mathew_john.jpg"
       },
       {
        "time": "12:40PM - 12:45PM",
        "title": "Panel Discussion Q&A",
        "speaker": "Dr. Mathew John",
        "city": "Thiruvananthapuram",
        "group": null,
        "photo": "/faculty/f_mathew_john.jpg"
       },
       {
        "time": "12:45PM - 01:40PM",
        "title": "",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "",
        "title": "GURU VANDANA",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "01:05PM - 01:40PM",
        "title": "",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "break",
      "time": "01:45PM - 02:15PM",
      "label": "Lunch"
     },
     {
      "kind": "session",
      "title": "GLP-1 RA- Moving Beyond Diabetes Management",
      "time": "02:15PM - 03:00PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Chandni jain",
        "city": "Mumbai",
        "photo": "/faculty/f_chandni_jain.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Aarti Ullal",
        "city": "Mumbai",
        "photo": "/faculty/f_aarti_ullal.jpg"
       }
      ],
      "talks": [
       {
        "time": "02:15PM - 02:35PM",
        "title": "The Innovator Semaglutide 2.4 mg Signature: Science that Shapes Clinical Outcomes and Confidence",
        "speaker": "Dr. Hemant Thacker",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_hemant_thacker.jpg"
       },
       {
        "time": "02:35PM - 02:50PM",
        "title": "Turning the Tide in MASH: Histologic Improvement and Metabolic Value with Innovator Semaglutide 2.4 mg",
        "speaker": "Dr. Sanjeev Phatak",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_sanjeev_phatak.jpg"
       },
       {
        "time": "02:50PM - 03:00PM",
        "title": "Q&A Discussions",
        "speaker": "Dr. Hemant Thacker",
        "city": "Mumbai",
        "group": null,
        "cospeakers": [
         {
          "name": "Dr. Sanjeev Phatak",
          "city": "Ahmedabad",
          "photo": "/faculty/f_sanjeev_phatak.jpg"
         }
        ],
        "photo": "/faculty/f_hemant_thacker.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "AARO- Unmute Yourself",
      "time": "03:00PM - 03:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Priti Sanghavi",
        "city": "Mumbai",
        "photo": "/faculty/f_priti_sanghavi.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Amit Bhondve",
        "city": "Mumbai",
        "photo": "/faculty/f_amit_bhondve.jpg"
       }
      ],
      "talks": [
       {
        "time": "03:00PM - 03:15PM",
        "title": "",
        "speaker": "Dr. B. M. Makkar",
        "city": "New Delhi",
        "group": null,
        "photo": "/faculty/f_b_m_makkar.jpg"
       },
       {
        "time": "03:15PM - 03:30PM",
        "title": "",
        "speaker": "Dr. Neeta Deshpande",
        "city": "Belgaum",
        "group": null,
        "photo": "/faculty/f_neeta_deshpande.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Panel Discussion: Enhanced Outcomes in GLP1 Based Therapy - Role of DSN",
      "time": "03:30PM - 04:15PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Shardul Kothary",
        "city": "Mumbai",
        "photo": "/faculty/f_shardul_kothary.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Nitin Gade",
        "city": "Pune",
        "photo": "/faculty/f_nitin_gade.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Archana Sarda",
        "city": "Aurangabad",
        "photo": "/faculty/f_archana_sarda.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Usha Sriram",
        "city": "Chennai",
        "photo": "/faculty/f_usha_sriram.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Mihir Raut",
        "city": "Mumbai",
        "photo": "/faculty/f_mihir_raut.jpg"
       }
      ],
      "talks": [],
      "type": "Panel"
     },
     {
      "kind": "session",
      "title": "What's the New Buzz?",
      "time": "04:15PM - 05:55PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Ramesh Dargad",
        "city": "Mumbai",
        "photo": "/faculty/f_ramesh_dargad.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Charusheela Kohle",
        "city": "Mumbai",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "04:15PM - 04:35PM",
        "title": "MASLD -  Role of Saroglitazaar- A Dual PPAR Agonist",
        "speaker": "Dr. Neeta Deshpande",
        "city": "Belgaum",
        "group": null,
        "photo": "/faculty/f_neeta_deshpande.jpg"
       },
       {
        "time": "04:35PM - 04:55PM",
        "title": "Keynote - CGM in T2DM - FreeDM2 & Beyond",
        "speaker": "Dr. Lalantha Leelarathna",
        "city": "UK",
        "group": null,
        "photo": "/faculty/f_lalantha_leelarathna.jpg"
       },
       {
        "time": "04:55PM - 05:15PM",
        "title": "From Vaccine to Vaccination: Changing the Course of Dengue",
        "speaker": "Dr. Shashank Joshi",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_shashank_joshi.jpg"
       },
       {
        "time": "05:15PM - 05:35PM",
        "title": "Advancing Shingles Prevention Strategies in Patients with Diabetes: Challenges and Opportunities",
        "speaker": "Dr. Harshad Limaye",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "05:35PM - 05:55PM",
        "title": "Remission of Diabetes in SEA- Is it a Viable Option",
        "speaker": "Dr. Manilka Sumantilleke",
        "city": "Sri Lanka",
        "group": null,
        "photo": "/faculty/f_manilka_sumantilleke.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Once-Daily to Once-Weekly Insulin Symposium",
      "time": "05:55PM - 06:40PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Ashish Sarwate",
        "city": "Mumbai",
        "photo": "/faculty/f_ashish_sarwate.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Dharmen Punatar",
        "city": "Mumbai",
        "photo": "/faculty/f_dharmen_punatar.jpg"
       }
      ],
      "talks": [
       {
        "time": "05:55PM - 06:25PM",
        "title": "Simplifying Basal Insulin Therapy with Icodec: Balancing Convenience, Efficacy and Safety",
        "speaker": "Dr. Alice Cheng",
        "city": "Canada",
        "group": null,
        "photo": "/faculty/f_alice_cheng.jpg"
       },
       {
        "time": "06:25PM - 06:40PM",
        "title": "From Daily to Weekly Basal Insulin: Integrating Insulin Icodec to Routine Diabetes Care",
        "speaker": "Dr. Jothydev Kesavadev",
        "city": "Thiruvananthapuram",
        "group": null,
        "photo": "/faculty/f_jothydev_kesavadev.jpg"
       }
      ],
      "type": "Symposium"
     },
     {
      "kind": "session",
      "title": "T2D Reimagined: Holistic Care in the Era of Tirzepatide",
      "time": "06:45PM - 07:45PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. G. Vijaya Kumar",
        "city": "Chennai",
        "photo": "/faculty/f_g_vijaya_kumar.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Mudit Sabharwal",
        "city": "New Delhi",
        "photo": "/faculty/f_mudit_sabharwal.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Manoj Patel",
        "city": "Mumbai",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "06:45PM - 06:50PM",
        "title": "Context Setting",
        "speaker": "Dr. G. Vijaya Kumar",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_g_vijaya_kumar.jpg"
       },
       {
        "time": "06:50PM - 07:05PM",
        "title": "Glycaemic Control: Driving Patients to Near-Normal Glucose",
        "speaker": "Dr. Rahul Baxi",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_rahul_baxi.jpg"
       },
       {
        "time": "07:05PM - 07:20PM",
        "title": "Weight and Metabolic Health: Targeting the Root, Not just Symptoms",
        "speaker": "Dr. Piya Ballani",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_piya_ballani.jpg"
       },
       {
        "time": "07:20PM - 07:35PM",
        "title": "Multisystem Burden of T2D: Heart, Kidney, Liver and Beyond",
        "speaker": "Dr. Bharat Saboo",
        "city": "Indore",
        "group": null,
        "photo": "/faculty/f_bharat_saboo.jpg"
       },
       {
        "time": "07:35PM - 07:45PM",
        "title": "Q&A Discussions",
        "speaker": "Dr. G. Vijaya Kumar",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_g_vijaya_kumar.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Zydus Wellness Nutritional Panel Discussion",
      "time": "07:45PM - 08:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Manoj Chawla",
        "city": "Mumbai",
        "photo": "/faculty/f_manoj_chawla.jpg"
       },
       {
        "role": "Panel",
        "name": "Prof. Peter Schwarz",
        "city": "Germany",
        "photo": "/faculty/f_peter_schwarz.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "photo": "/faculty/f_banshi_saboo.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Purvi Chawla",
        "city": "Mumbai",
        "photo": "/faculty/f_purvi_chawla.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Sunil Gupta",
        "city": "Nagpur",
        "photo": "/faculty/f_sunil_gupta.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. B. M. Makkar",
        "city": "New Delhi",
        "photo": "/faculty/f_b_m_makkar.jpg"
       }
      ],
      "talks": [],
      "type": "Panel"
     },
     {
      "kind": "break",
      "time": "08:30PM - 10:00PM",
      "label": "Dinner"
     }
    ],
    "sessionCount": 12
   },
   {
    "hall": "IDF HALL",
    "items": [
     {
      "kind": "break",
      "time": "09:00AM Onwards",
      "label": "Registration & Breakfast"
     },
     {
      "kind": "session",
      "title": "ALL SPEAKERS",
      "time": "ALL SPEAKERS",
      "people": [],
      "talks": [],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "@100 patients- My New Diabetes Clinic",
      "time": "10:30AM - 11:00AM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Rutul Gokalani",
        "city": "Ahmedabad",
        "photo": "/faculty/f_rutul_gokalani.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Ninad Gor",
        "city": "Bhuj",
        "photo": "/faculty/f_ninad_gor.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Aswin Mukundan",
        "city": "Kozhikode",
        "photo": "/faculty/f_aswin_mukundan.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Dewark Sharma",
        "city": "Kokrajhar",
        "photo": "/faculty/f_dewark_sharma.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Prasanth Sankar",
        "city": "Pathanamthitta",
        "photo": "/faculty/f_prasanth_sankar.jpg"
       }
      ],
      "talks": [],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Elixirs for CKM & Uncontrolled HT",
      "time": "11:00AM - 12:45PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Manilka Sumantilleke",
        "city": "Sri Lanka",
        "photo": "/faculty/f_manilka_sumantilleke.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Sanhita Walawalkar",
        "city": "Mumbai",
        "photo": "/faculty/f_sanhita_walawalkar.jpg"
       }
      ],
      "talks": [
       {
        "time": "11:00AM - 11:20AM",
        "title": "Hyperkalaemia in CKD- Variation in Clinical Impact by Disease Stage",
        "speaker": "Dr. Hemal Shah",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_hemal_shah.jpg"
       },
       {
        "time": "11:20AM - 11:40AM",
        "title": "Finerenone in Clinical Practice: Transforming the Management of Cardiorenal Complications in DKD",
        "speaker": "Dr. Ketan Mehta",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "11:40AM - 12:00PM",
        "title": "2026 Vision of Managing Type 2 DM with CKD - Optimising the Prevention Continum",
        "speaker": "Dr. Pradeep Talwalkar",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_pradeep_talwalkar.jpg"
       },
       {
        "time": "12:00PM - 12:20PM",
        "title": "Aldosterone the Saboteur in Persistently Uncontrolled Hypertension",
        "speaker": "Dr. Jothydev Kesavadev",
        "city": "Thiruvananthapuram",
        "group": null,
        "photo": "/faculty/f_jothydev_kesavadev.jpg"
       },
       {
        "time": "12:20PM - 12:40PM",
        "title": "Evolving Role of Aldosterone Synthase Inhibitors in Management of Uncontrolled",
        "speaker": "Dr. G. Vijaya Kumar",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_g_vijaya_kumar.jpg"
       },
       {
        "time": "12:40PM - 12:45PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Insulin in 2026",
      "time": "12:45PM - 01:45PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Mahendra Patel",
        "city": "Mumbai",
        "photo": "/faculty/f_mahendra_patel.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Amruta Prabhu",
        "city": "Mumbai",
        "photo": "/faculty/f_amruta_prabhu.jpg"
       }
      ],
      "talks": [
       {
        "time": "12:45PM - 01:05PM",
        "title": "Breaking Through Insulin Initiation Barriers with Premixes",
        "speaker": "Dr. Sunil Gupta",
        "city": "Nagpur",
        "group": null,
        "photo": "/faculty/f_sunil_gupta.jpg"
       },
       {
        "time": "01:05PM - 01:25PM",
        "title": "Modulating Early PPG Excursions and 4-Hour Glycemic Trajectory",
        "speaker": "Dr. Sandeep Suri",
        "city": "Hissar",
        "group": null,
        "photo": "/faculty/f_sandeep_suri.jpg"
       },
       {
        "time": "01:25PM - 01:45PM",
        "title": "Clearing the Air Around Inhaled Insulin",
        "speaker": "Dr. Supratik Bhattacharyya",
        "city": "Kolkata",
        "group": null,
        "photo": "/faculty/f_supratik_bhattacharyya.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "break",
      "time": "01:45PM - 02:15PM",
      "label": "Lunch"
     },
     {
      "kind": "session",
      "title": "Preventing Limb Loss (Theme: Saving Every Foot)",
      "time": "02:15PM - 03:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Anoosha Bhandarkar",
        "city": "Dharwad",
        "photo": "/faculty/f_anoosha_bhandarkar.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Ayaz Ansari",
        "city": "Mumbai",
        "photo": "/faculty/f_ayaz_ansari.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Sachin Mohite",
        "city": "Mumbai",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "02:15PM - 02:20PM",
        "title": "Context Setting",
        "speaker": "Dr. Anoosha Bhandarkar",
        "city": "Dharwad",
        "group": null,
        "photo": "/faculty/f_anoosha_bhandarkar.jpg"
       },
       {
        "time": "02:20PM - 02:35PM",
        "title": "Who is at Highest Risk for Amputation?\nRisk Stratification and Screening",
        "speaker": "Dr. Amit Naghate",
        "city": "Aurangabad",
        "group": null,
        "photo": "/faculty/f_amit_naghate.jpg"
       },
       {
        "time": "02:35PM - 02:50PM",
        "title": "Neuropathy: Detect Early, Act Early\nClinical Tools and Emerging Diagnostics",
        "speaker": "Dr. Abhishek Shrivastava",
        "city": "Jabalpur",
        "group": null,
        "photo": "/faculty/f_abhishek_shrivastava.jpg"
       },
       {
        "time": "02:50PM - 03:10PM",
        "title": "International Expert-Pad in Diabetes: The Missed Diagnosis\nScreening, Imaging and Revascularisation",
        "speaker": "Dr. Thushan Gooneratne",
        "city": "Sri Lanka",
        "group": null,
        "photo": null
       },
       {
        "time": "03:10PM - 03:25PM",
        "title": "The Modern Diabetic Foot Team\nOff-Loading, Wound Care, Infection Control and Limb Salvage",
        "speaker": "Dr. Jessy Thomas",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_jessy_thomas.jpg"
       },
       {
        "time": "03:25PM - 03:30PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Evergreen Therapeutics",
      "time": "03:30PM - 04:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Supratik Bhattacharyya",
        "city": "Kolkata",
        "photo": "/faculty/f_supratik_bhattacharyya.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Anchin Kalia",
        "city": "Jaipur",
        "photo": "/faculty/f_anchin_kalia.jpg"
       }
      ],
      "talks": [
       {
        "time": "03:30PM - 03:50PM",
        "title": "Insulin Resistance to Organ Protection- Pioglitazone Based Combinations",
        "speaker": "Dr. Vijay Panikar",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_vijay_panikar.jpg"
       },
       {
        "time": "03:50PM - 04:05PM",
        "title": "Gliclazide Reimagined : My SU Choice",
        "speaker": "Dr. Aravinda Jagadeesha",
        "city": "Bengaluru",
        "group": null,
        "photo": "/faculty/f_aravinda_jagadeesha.jpg"
       },
       {
        "time": "04:05PM - 04:20PM",
        "title": "Overcoming Inertia with the Enduring Modern SUs + Metformin",
        "speaker": "Dr. Alka Gandhi",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_alka_gandhi.jpg"
       },
       {
        "time": "04:20PM - 04:30PM",
        "title": "Discussion",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "T1D Management in 2026",
      "time": "04:30PM - 05:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Manisha Gupta",
        "city": "Kanpur",
        "photo": "/faculty/f_manisha_gupta.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Sybal Dbritto",
        "city": "Mumbai",
        "photo": "/faculty/f_sybal_dbritto.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Trija Banerjee",
        "city": "Mumbai",
        "photo": "/faculty/f_trija_banerjee.jpg"
       }
      ],
      "talks": [
       {
        "time": "04:30PM - 04:35PM",
        "title": "Context Setting",
        "speaker": "Dr. Manisha Gupta",
        "city": "Kanpur",
        "group": null,
        "photo": "/faculty/f_manisha_gupta.jpg"
       },
       {
        "time": "04:35PM - 04:55PM",
        "title": "Adult Onset Diabetes is Not Always T2DM",
        "speaker": "Dr. Rishi Shukla",
        "city": "Kanpur",
        "group": null,
        "photo": "/faculty/f_rishi_shukla.jpg"
       },
       {
        "time": "04:55PM - 05:10PM",
        "title": "Limited Resources Cannot be an Excuse for Poor Control",
        "speaker": "Dr. Archana Sarda",
        "city": "Aurangabad",
        "group": null,
        "photo": "/faculty/f_archana_sarda.jpg"
       },
       {
        "time": "05:10PM - 05:25PM",
        "title": "A Deep Dive into Teplizumab and Emerging Therapies for T1D",
        "speaker": "Dr. Suresh Damodaran",
        "city": "Coimbatore",
        "group": null,
        "photo": "/faculty/f_suresh_damodaran.jpg"
       },
       {
        "time": "05:25PM - 05:30PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Keynote",
      "time": "05:30PM - 06:10PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Banshi Saboo",
        "city": "Ahmedabad",
        "photo": "/faculty/f_banshi_saboo.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Purvi Chawla",
        "city": "Mumbai",
        "photo": "/faculty/f_purvi_chawla.jpg"
       }
      ],
      "talks": [
       {
        "time": "05:30PM - 05:50PM",
        "title": "Rising Temperatures, Rising Risks: Rethinking Diabetes Care in a Warming World",
        "speaker": "Dr. Monika Arora",
        "city": "New Delhi",
        "group": null,
        "photo": "/faculty/f_monika_arora.jpg"
       },
       {
        "time": "05:50PM - 06:10PM",
        "title": "",
        "speaker": "Dr. Bishwajit Bhowmik",
        "city": "Bangladesh",
        "group": null,
        "photo": "/faculty/f_bishwajit_bhowmik.jpg"
       }
      ],
      "type": "Keynote"
     },
     {
      "kind": "session",
      "title": "Preventing Heart Disease (Theme: Beyond Glycaemic Control-HEART MATTERS)",
      "time": "06:10PM - 07:20PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Smruti Hora",
        "city": "Mumbai",
        "photo": "/faculty/f_smruti_hora.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Chandrkant Rachabattuni",
        "city": "Pune",
        "photo": "/faculty/f_chandrkant_rachabattuni.jpg"
       }
      ],
      "talks": [
       {
        "time": "06:10PM - 06:25PM",
        "title": "The Cardiometabolic Revolution: Heart-First Approach in Diabetes",
        "speaker": "Dr. Brij Mohan",
        "city": "Kanpur",
        "group": null,
        "photo": "/faculty/f_brij_mohan.jpg"
       },
       {
        "time": "06:25PM - 06:45PM",
        "title": "Heart Failure: The Forgotten Cardiovascular Complication Early Diagnosis and Prevention Strategies",
        "speaker": "Dr. P. C. Manoria",
        "city": "Indore",
        "group": null,
        "photo": "/faculty/f_p_c_manoria.jpg"
       },
       {
        "time": "06:45PM - 07:00PM",
        "title": "Obesity and Cardiovascular Risk",
        "speaker": "Dr. Sanjay Agarwal",
        "city": "Pune",
        "group": null,
        "photo": "/faculty/f_sanjay_agarwal.jpg"
       },
       {
        "time": "07:00PM - 07:15PM",
        "title": "Intensive BP Control- How Low Should We Go?",
        "speaker": "Dr. Bhavesh Vajifdar",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "07:15PM - 07:20PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Technology in Diabetes",
      "time": "07:20PM -  08:45PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Suresh Purohit",
        "city": "Mumbai",
        "photo": "/faculty/f_suresh_purohit.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Vishakha Mhatre",
        "city": "Mumbai",
        "photo": "/faculty/f_vishakha_mhatre.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Anushree Mehta",
        "city": "Mumbai",
        "photo": "/faculty/f_anushree_mehta.jpg"
       }
      ],
      "talks": [
       {
        "time": "07:20PM - 07:25PM",
        "title": "Context Setting",
        "speaker": "Dr. Suresh Purohit",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_suresh_purohit.jpg"
       },
       {
        "time": "07:25PM - 07:40PM",
        "title": "Digital Tools for Doctors, Patients and Caregivers",
        "speaker": "Dr. Bhagwati Prasad",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_bhagwati_prasad.jpg"
       },
       {
        "time": "07:40PM - 07:55PM",
        "title": "Technology & AI- Same-Same or Different ?",
        "speaker": "Dr. Aniket Inamdar",
        "city": "Omerga",
        "group": null,
        "photo": "/faculty/f_aniket_inamdar.jpg"
       },
       {
        "time": "07:55PM - 08:10PM",
        "title": "Connected Wearables- The Metabolic Display",
        "speaker": "Dr. Rakesh Parikh",
        "city": "Jaipur",
        "group": null,
        "photo": "/faculty/f_rakesh_parikh.jpg"
       },
       {
        "time": "08:10PM - 08:25PM",
        "title": "AID - Data Review and Treatment Optimisation",
        "speaker": "Dr. Lalantha Leelarathna",
        "city": "UK",
        "group": null,
        "photo": "/faculty/f_lalantha_leelarathna.jpg"
       },
       {
        "time": "08:25PM - 08:40PM",
        "title": "My Top 5 Practical AI Solutions for Doctors",
        "speaker": "Dr. Amit Kumar Dey",
        "city": "Kolkata",
        "group": null,
        "photo": "/faculty/f_amit_kumar_dey.jpg"
       },
       {
        "time": "08:40PM - 08:45PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "break",
      "time": "08:45PM - 10:00PM",
      "label": "Dinner"
     }
    ],
    "sessionCount": 10
   },
   {
    "hall": "RAHEJA HALL",
    "items": [
     {
      "kind": "break",
      "time": "09:00AM Onwards",
      "label": "Registration & Breakfast"
     },
     {
      "kind": "session",
      "title": "Applied AI for Diabetologists: Data, Decisions, and Patient Care",
      "time": "10:00AM - 12:00PM",
      "people": [],
      "talks": [
       {
        "time": "10:00AM - 10:20AM",
        "title": "Digital Health for Diabetologists: Hospital Information System (HIS), \nElectronic Medical Record (EMR) and Practical Implementation Essentials",
        "speaker": "Prof. Dr. Kalyani Addya",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "10:20AM - 10:40AM",
        "title": "Integrating AI into Diabetes Practice: Early Detection, Risk Stratification, and \nCare Planning",
        "speaker": "Prof. Raghav Tandon",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "10:40AM - 12:00PM",
        "title": "Hands on training on “Integrating AI into Diabetes Practice: Early Detection, Risk Stratification, and Care Planning",
        "speaker": "Prof. Dr. Kalyani Addya",
        "city": "Mumbai",
        "group": null,
        "photo": null
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "The Burning Question 3",
      "time": "12:00PM - 12:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Rishi Shukla",
        "city": "Kanpur",
        "photo": "/faculty/f_rishi_shukla.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Aniket Inamdar",
        "city": "Omerga",
        "photo": "/faculty/f_aniket_inamdar.jpg"
       }
      ],
      "talks": [
       {
        "time": "",
        "title": "Pharmacotherapy in Adolescent Obesity",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "12:00PM - 12:15PM",
        "title": "Yes",
        "speaker": "Dr. Shefali Karkhanis",
        "city": "Mumbai",
        "group": "Pharmacotherapy in Adolescent Obesity",
        "photo": "/faculty/f_shefali_karkhanis.jpg"
       },
       {
        "time": "12:15PM - 12:30PM",
        "title": "No",
        "speaker": "Dr. Mudit Sabharwal",
        "city": "Delhi",
        "group": "Pharmacotherapy in Adolescent Obesity",
        "photo": "/faculty/f_mudit_sabharwal.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Preventing MASLD (Theme: Saving the Liver Before Fibrosis Develops)",
      "time": "12:40PM - 01:40PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Pranjali Shah",
        "city": "Mumbai",
        "photo": "/faculty/f_pranjali_shah.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Amit Kumar Dey",
        "city": "Kolkata",
        "photo": "/faculty/f_amit_kumar_dey.jpg"
       }
      ],
      "talks": [
       {
        "time": "12:40PM - 12:55PM",
        "title": "Should Every Person with Diabesity Be Screened for MASLD?",
        "speaker": "Dr. Rukiya Surya",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_rukiya_surya.jpg"
       },
       {
        "time": "12:55PM - 01:10PM",
        "title": "Detecting Liver Fibrosis Early\nFibroScan, FIB-4, ELF Score and Imaging",
        "speaker": "Dr. Nimmi Mulwani",
        "city": "Ahmedabad",
        "group": null,
        "photo": "/faculty/f_nimmi_mulwani.jpg"
       },
       {
        "time": "01:10PM - 01:25PM",
        "title": "Medical Management of MASLD in Diabetes\nWeight Loss Therapies, Incretins and Emerging Drugs",
        "speaker": "Dr. Vinod Methil",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_vinod_methil.jpg"
       },
       {
        "time": "01:25PM - 01:40PM",
        "title": "Panel Discussion",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "break",
      "time": "01:40PM - 02:15PM",
      "label": "Lunch"
     },
     {
      "kind": "session",
      "title": "The Burning Question 4 (14 mins talk time + 2 mins rebuttal)",
      "time": "02:30PM - 03:00PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Dhruvi Hasnani",
        "city": "Ahmedabad",
        "photo": "/faculty/f_dhruvi_hasnani.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Manisha Talim",
        "city": "Mumbai",
        "photo": "/faculty/f_manisha_talim.jpg"
       }
      ],
      "talks": [
       {
        "time": "",
        "title": "CGM in Non-Insulin Using T2DM",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "02:30PM - 02:42PM",
        "title": "Why?",
        "speaker": "Dr. Binayak Sinha",
        "city": "Kolkata",
        "group": "CGM in Non-Insulin Using T2DM",
        "photo": "/faculty/f_binayak_sinha.jpg"
       },
       {
        "time": "02:43PM - 02:55PM",
        "title": "Why Not?",
        "speaker": "Dr. Alice Cheng",
        "city": "Canada",
        "group": "CGM in Non-Insulin Using T2DM",
        "photo": "/faculty/f_alice_cheng.jpg"
       },
       {
        "time": "02:55PM - 03:00PM",
        "title": "Rebuttal",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Practical AI for Doctors in 2026",
      "time": "03:00PM - 04:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Ritu Johari",
        "city": "Mumbai",
        "photo": "/faculty/f_ritu_johari.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Prasanth Sankar",
        "city": "Pathanamthitta",
        "photo": "/faculty/f_prasanth_sankar.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Rajesh Deshmane",
        "city": "",
        "photo": "/faculty/f_rajesh_deshmane.jpg"
       }
      ],
      "talks": [
       {
        "time": "03:00PM - 03:05PM",
        "title": "Context Setting",
        "speaker": "Dr. Ritu Johari",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_ritu_johari.jpg"
       },
       {
        "time": "03:05PM - 03:20PM",
        "title": "Using AI to Push the Boundaries of My Diabetes Clinic and to Market It",
        "speaker": "Dr. Bharat Saboo",
        "city": "Indore",
        "group": null,
        "photo": "/faculty/f_bharat_saboo.jpg"
       },
       {
        "time": "03:20PM - 03:35PM",
        "title": "The Heart of AI: Learn to Write Prompts",
        "speaker": "Dr. Suhas Erande",
        "city": "Pune",
        "group": null,
        "photo": "/faculty/f_suhas_erande.jpg"
       },
       {
        "time": "03:35PM - 03:50PM",
        "title": "The AI Coach After the Doctor Has Seen You: The Power of a Chatbot",
        "speaker": "Dr. S. V. Kulkarni",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_s_v_kulkarni.jpg"
       },
       {
        "time": "03:50PM - 04:05PM",
        "title": "Don't Just Read AGP, Interrogate it with AI - Some Use Cases",
        "speaker": "Dr. Alok Modi",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_alok_modi.jpg"
       },
       {
        "time": "04:05PM - 04:20PM",
        "title": "AI Unplugged: From Demonstration to Daily Diabetes Practice",
        "speaker": "ALL SPEAKERS",
        "city": "",
        "group": null,
        "photo": null
       },
       {
        "time": "04:20PM - 04:30PM",
        "title": "Panel Discussion & Audience Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "The 2nd Opinion Symposium",
      "time": "04:30PM - 05:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Santosh Malpani",
        "city": "Nanded",
        "photo": "/faculty/f_santosh_malpani.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Smita patil",
        "city": "",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "04:30PM - 04:45PM",
        "title": "I am Prescribed Insulin",
        "speaker": "Dr. Jaydip Revale",
        "city": "Satara",
        "group": null,
        "photo": "/faculty/f_jaydip_revale.jpg"
       },
       {
        "time": "04:45PM - 05:00PM",
        "title": "My Doctor Keeps Recommending CGM",
        "speaker": "Dr. Amit Rajput",
        "city": "Jalgaon",
        "group": null,
        "photo": "/faculty/f_amit_rajput.jpg"
       },
       {
        "time": "05:00PM - 05:15PM",
        "title": "The SGLT2i is Causing GU Infection",
        "speaker": "Dr. Harshpreet Tuteja",
        "city": "Ambikapur",
        "group": null,
        "photo": "/faculty/f_harshpreet_tuteja.jpg"
       },
       {
        "time": "05:15PM - 05:30PM",
        "title": "I am Not Obese - Yet I Have Been Prescribed GLP-1RAs",
        "speaker": "Dr. Subhajyoti Ghosh",
        "city": "Dibrugarh",
        "group": null,
        "photo": "/faculty/f_subhajyoti_ghosh.jpg"
       }
      ],
      "type": "Symposium"
     },
     {
      "kind": "session",
      "title": "Controversies in Diabetes 2026",
      "time": "05:30PM - 06:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Abhishek Raha",
        "city": "Lumbding",
        "photo": "/faculty/f_abhishek_raha.jpg"
       },
       {
        "role": "Chairperson",
        "name": "manisha Gupta",
        "city": "",
        "photo": "/faculty/f_manisha_gupta.jpg"
       }
      ],
      "talks": [
       {
        "time": "05:30PM – 05:45PM",
        "title": "Insulin in T2DM- Is it Really Needed ?",
        "speaker": "Dr. Rajesh Deshmane",
        "city": "Kolhapur",
        "group": null,
        "photo": "/faculty/f_rajesh_deshmane.jpg"
       },
       {
        "time": "05:45PM – 06:00PM",
        "title": "Metformin in Newly Diagnosed T2DM with SGLT2I & GLPs Becoming Affordable in India",
        "speaker": "Dr. Santosh Malpani",
        "city": "Nanded",
        "group": null,
        "photo": "/faculty/f_santosh_malpani.jpg"
       },
       {
        "time": "06:00PM – 06:15PM",
        "title": "GLP- 1 RA in T1 DM -  Off-Label & Worth it or Risky ?",
        "speaker": "Dr. Piyush Desai",
        "city": "Surat",
        "group": null,
        "photo": "/faculty/f_piyush_desai.jpg"
       },
       {
        "time": "06:15PM – 06:30PM",
        "title": "Diabetes Remission- Genuine Goal or Golmal?",
        "speaker": "Dr. Rajnish Saxena",
        "city": "Ajmer",
        "group": null,
        "photo": "/faculty/f_rajnish_saxena.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Acute Situations in DM",
      "time": "06:30PM - 08:00PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "dr Brij Mohan",
        "city": "kanpur",
        "photo": "/faculty/f_brij_mohan.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Vipul Chawda",
        "city": "",
        "photo": "/faculty/f_vipul_chawda.jpg"
       }
      ],
      "talks": [
       {
        "time": "06:30PM - 06:45PM",
        "title": "Severe Hypoglycemia in DM with CKD on SUs",
        "speaker": "Dr. Malay Parekh",
        "city": "Rajkot",
        "group": null,
        "photo": "/faculty/f_malay_parekh.jpg"
       },
       {
        "time": "06:45PM - 07:00PM",
        "title": "Pt Started on 60 mg Oral Prednisolone for Skin Reaction- DM/HT/IHD",
        "speaker": "Dr. A. Shanmugam",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_a_shanmugam.jpg"
       },
       {
        "time": "07:00PM - 07:15PM",
        "title": "Casuality Call- RBS- 370, Patient Breathless, Ketones - 2+",
        "speaker": "Dr. Utkal Kishore Khadanga",
        "city": "Bhubaneswar",
        "group": null,
        "photo": "/faculty/f_utkal_kishore_khadanga.jpg"
       },
       {
        "time": "07:15PM - 07:30PM",
        "title": "Severe Abdominal Pain & Vomiting, Pt on 3 OADs",
        "speaker": "Dr. Anubha Varma",
        "city": "Prayagraj",
        "group": null,
        "photo": "/faculty/f_anubha_varma.jpg"
       },
       {
        "time": "07:30PM - 07:45PM",
        "title": "Casuality Call- RBS- 370, Patient Breathless, Ketones - 2+",
        "speaker": "Dr. Sonali Bhojane",
        "city": "Pune",
        "group": null,
        "photo": "/faculty/f_sonali_bhojane.jpg"
       },
       {
        "time": "07:45PM - 08:00PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "break",
      "time": "08:30PM - 10:00PM",
      "label": "Dinner"
     },
     {
      "kind": "session",
      "title": "Sodium Zirconium Cyclosilicate in Hyperkalemia Management",
      "time": "",
      "people": [],
      "talks": [],
      "type": "Session"
     }
    ],
    "sessionCount": 9
   }
  ]
 },
 {
  "day": "Day 3",
  "date": "6th September, 2026 (Sunday)",
  "halls": [
   {
    "hall": "DRS HALL",
    "items": [
     {
      "kind": "break",
      "time": "08:30AM Onwards",
      "label": "Registration & Breakfast"
     },
     {
      "kind": "session",
      "title": "MDCF Oration",
      "time": "09:30AM - 10:00AM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Purvi Chawla",
        "city": "Mumbai",
        "photo": "/faculty/f_purvi_chawla.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Shaunak Hora",
        "city": "Mumbai",
        "photo": "/faculty/f_shaunak_hora.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Mr. Tushar Dalal",
        "city": "Mumbai",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "",
        "title": "The Female Face Of Diabetes Across the Life Course",
        "speaker": "Dr. Noor Al Busaidi",
        "city": "Oman",
        "group": null,
        "photo": "/faculty/f_noor_al_busaidi.jpg"
       },
       {
        "time": "10:00AM - 10:30AM",
        "title": "Living with T1D",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "",
        "title": "Experts:",
        "speaker": "Ms. Jyotsana Rangeen",
        "city": "New Delhi",
        "group": "Living with T1D",
        "cospeakers": [
         {
          "name": "Ms. Nishtha Kanal",
          "city": "Mumbai",
          "photo": "/faculty/f_nishtha_kanal.jpg"
         }
        ],
        "photo": "/faculty/f_jyotsana_rangeen.jpg"
       }
      ],
      "type": "Oration"
     },
     {
      "kind": "session",
      "title": "Combinations & Innovation",
      "time": "10:30AM - 11:30AM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Manas Save",
        "city": "Mumbai",
        "photo": "/faculty/f_manas_save.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Aashna Patil",
        "city": "Mumbai",
        "photo": "/faculty/f_aashna_patil.jpg"
       }
      ],
      "talks": [
       {
        "time": "10:30AM - 10:50AM",
        "title": "Synergistic Fortitude: How Complementary Mechanisms Outlast Monotherapy",
        "speaker": "Dr. Manoj Chadha",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_manoj_chadha.jpg"
       },
       {
        "time": "10:50AM - 11:10AM",
        "title": "iGlarLixi as a First Injectable Simplifying Real-World Clinical Practice",
        "speaker": "Dr. Rajeev Chawla",
        "city": "New Delhi",
        "group": null,
        "photo": "/faculty/f_rajeev_chawla.jpg"
       },
       {
        "time": "11:10AM - 11:30AM",
        "title": "Evidence Continuum for Second Generation Basal Insulin",
        "speaker": "Dr. Binayak Sinha",
        "city": "Kolkata",
        "group": null,
        "photo": "/faculty/f_binayak_sinha.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Beyond The Scale: Redefining Obesity",
      "time": "11:30AM - 12:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Reema Kashiva",
        "city": "Pune",
        "photo": "/faculty/f_reema_kashiva.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Nikhil Prabhu",
        "city": "Mumbai",
        "photo": "/faculty/f_nikhil_prabhu.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Indrashish Mukherjee",
        "city": "Lucknow",
        "photo": "/faculty/f_indrashish_mukherjee.jpg"
       }
      ],
      "talks": [
       {
        "time": "11:30AM - 11:35AM",
        "title": "Introduction and Context Setting",
        "speaker": "Dr. Reema Kashiva",
        "city": "Pune",
        "group": null,
        "photo": "/faculty/f_reema_kashiva.jpg"
       },
       {
        "time": "11:35AM - 11:50AM",
        "title": "Beyond BMI: Practical Diagnosis & Risk Stratification in Obesity",
        "speaker": "Dr. L. Sreenivasa Murthy",
        "city": "Bengaluru",
        "group": null,
        "photo": "/faculty/f_l_sreenivasa_murthy.jpg"
       },
       {
        "time": "11:50AM - 12:05PM",
        "title": "Bridging the Gap: Overcoming Clinical Inertia in Obesity Management",
        "speaker": "Dr. Mahesh Padsalge",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_mahesh_padsalge.jpg"
       },
       {
        "time": "12:05PM - 12:20PM",
        "title": "The Long Game: Sustained Outcomes and Chronic Care Model in Obesity",
        "speaker": "Dr. Girish Parmar",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_girish_parmar.jpg"
       },
       {
        "time": "12:20PM - 12:30PM",
        "title": "Panel Discussion",
        "speaker": "Dr. Reema Kashiva",
        "city": "Pune",
        "group": null,
        "photo": "/faculty/f_reema_kashiva.jpg"
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Trials & TRIUMPHS",
      "time": "12:30PM - 01:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Vipul Chavda",
        "city": "Ahmedabad",
        "photo": "/faculty/f_vipul_chavda.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Karthik Munichoodappa",
        "city": "Bengaluru",
        "photo": "/faculty/f_karthik_munichoodappa.jpg"
       }
      ],
      "talks": [
       {
        "time": "12:30PM - 12:45PM",
        "title": "The CATALYST Trial",
        "speaker": "Dr. Divya Saxena",
        "city": "Sonipat",
        "group": null,
        "photo": "/faculty/f_divya_saxena.jpg"
       },
       {
        "time": "12:45PM - 01:00PM",
        "title": "SURMOUNT Maintain",
        "speaker": "Dr. Sanjib Medhi",
        "city": "Guwahati",
        "group": null,
        "photo": "/faculty/f_sanjib_medhi.jpg"
       },
       {
        "time": "01:00PM - 01:15PM",
        "title": "Innovation to Impact: Role of Oral  Semaglutide in Metabolic Health",
        "speaker": "Dr. Abhay Sahoo",
        "city": "Bhubaneswar",
        "group": null,
        "photo": "/faculty/f_abhay_sahoo.jpg"
       },
       {
        "time": "01:15PM - 01:30PM",
        "title": "",
        "speaker": "Dr. Manoj Chawla",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_manoj_chawla.jpg"
       },
       {
        "time": "01:30PM - 01:40PM",
        "title": "Panel Discussion",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "break",
      "time": "01:40PM - 02:15PM",
      "label": "Lunch"
     },
     {
      "kind": "session",
      "title": "Points to Ponder",
      "time": "02:15PM - 03:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Vikram Vikhe",
        "city": "Pune",
        "photo": "/faculty/f_vikram_vikhe.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Amol Pawar",
        "city": "Mumbai",
        "photo": "/faculty/f_amol_pawar.jpg"
       }
      ],
      "talks": [
       {
        "time": "02:15PM - 02:30PM",
        "title": "ABPM Amongst PWD in India",
        "speaker": "Dr. Bijay Patni",
        "city": "Kolkata",
        "group": null,
        "photo": "/faculty/f_bijay_patni.jpg"
       },
       {
        "time": "02:30PM - 02:45PM",
        "title": "Management of T2DM Women - Pitfalls & Stigma in India",
        "speaker": "Dr. Meena Chhabra",
        "city": "New Delhi",
        "group": null,
        "photo": "/faculty/f_meena_chhabra.jpg"
       },
       {
        "time": "02:45PM - 03:00PM",
        "title": "Fasting, Festivals and Feasting — Cultural Influences on Medication Adherence",
        "speaker": "Dr. Akshay Kothari",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_akshay_kothari.jpg"
       },
       {
        "time": "03:00PM - 03:15PM",
        "title": "Travel for PWD in 2026 - My Checklist",
        "speaker": "Dr. Bensley Gonsalves",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_bensley_gonsalves.jpg"
       },
       {
        "time": "03:15PM - 03:30PM",
        "title": "Discussion",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "The Burning Question 5",
      "time": "03:30PM - 04:00PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Manoj Chawla",
        "city": "Mumbai",
        "photo": "/faculty/f_manoj_chawla.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Ami Sanghvi",
        "city": "",
        "photo": "/faculty/f_ami_sanghvi.jpg"
       }
      ],
      "talks": [
       {
        "time": "",
        "title": "Care Beyond Metabolics by a Diabetologist - Refer",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "03:30PM - 03:42PM",
        "title": "Yes",
        "speaker": "Dr. Aniruddh Makhecha",
        "city": "Mumbai",
        "group": "Care Beyond Metabolics by a Diabetologist - Refer",
        "photo": "/faculty/f_aniruddh_makhecha.jpg"
       },
       {
        "time": "03:43PM - 03:55PM",
        "title": "No",
        "speaker": "Dr. Manish Sachdev",
        "city": "Mumbai",
        "group": "Care Beyond Metabolics by a Diabetologist - Refer",
        "photo": "/faculty/f_manish_sachdev.jpg"
       },
       {
        "time": "03:55PM - 04:00PM",
        "title": "Rebuttal",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "04:00PM - 04:30PM",
        "title": "Valedictory",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     }
    ],
    "sessionCount": 6
   },
   {
    "hall": "IDF HALL",
    "items": [
     {
      "kind": "break",
      "time": "08:30AM Onwards",
      "label": "Registration & Breakfast"
     },
     {
      "kind": "session",
      "title": "Preventing Sarcopenia and Frailty (Theme: Adding Life to Year)",
      "time": "10:00AM - 11:15AM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Shabee Siddiqi",
        "city": "Mumbai",
        "photo": "/faculty/f_shabee_siddiqi.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Shruti Gangwani",
        "city": "Mumbai",
        "photo": "/faculty/f_shruti_gangwani.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Rahul Dhope",
        "city": "Pune",
        "photo": "/faculty/f_rahul_dhope.jpg"
       }
      ],
      "talks": [
       {
        "time": "10:00AM - 10:05AM",
        "title": "Context Setting",
        "speaker": "Dr. Shabee Siddiqi",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_shabee_siddiqi.jpg"
       },
       {
        "time": "10:05AM - 10:20AM",
        "title": "Sarcopenic Obesity: The Hidden Face of Diabesity",
        "speaker": "Dr. B. K. Singh",
        "city": "Patna",
        "group": null,
        "photo": "/faculty/f_b_k_singh.jpg"
       },
       {
        "time": "10:20AM - 10:40AM",
        "title": "Skeletal Muscle: The Forgotten Organ in Diabetes",
        "speaker": "Dr. Anil Virmani",
        "city": "Jamshedpur",
        "group": null,
        "photo": "/faculty/f_anil_virmani.jpg"
       },
       {
        "time": "10:40AM - 10:55AM",
        "title": "Exercise Prescriptions for Muscle Preservation\nResistance Training, Balance and Functional Fitness",
        "speaker": "Dr. K. N. Manohar",
        "city": "Bengaluru",
        "group": null,
        "photo": "/faculty/f_k_n_manohar.jpg"
       },
       {
        "time": "10:55AM - 11:10AM",
        "title": "Frailty Assessment in Diabetes Clinics\nScreening Tools, Deprescribing and Comprehensive Geriatric Care",
        "speaker": "Dr. Sanjay Singhla",
        "city": "New Delhi",
        "group": null,
        "photo": null
       },
       {
        "time": "11:10AM - 11:15AM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Mental Health & Diabetes (Theme: Caring for the Mind to Improve Metabolic Health)",
      "time": "11:15AM - 12:30PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Kavita Rane",
        "city": "Mumbai",
        "photo": "/faculty/f_kavita_rane.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Suresh Sawardekar",
        "city": "Mumbai",
        "photo": null
       },
       {
        "role": "Chairperson",
        "name": "Dr. Ishita Sachdev",
        "city": "Mumbai",
        "photo": "/faculty/f_ishita_sachdev.jpg"
       }
      ],
      "talks": [
       {
        "time": "11:15AM - 11:20AM",
        "title": "Context Setting",
        "speaker": "Dr. Kavita Rane",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_kavita_rane.jpg"
       },
       {
        "time": "11:20AM - 11:35AM",
        "title": "Diabetes Distress, Burnout and Depression",
        "speaker": "Dr. Seema Bagri",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_seema_bagri.jpg"
       },
       {
        "time": "11:35AM - 11:50AM",
        "title": "Obesity, Emotional Eating and Food Addiction\nBehavioural Interventions and Pharmacotherapy",
        "speaker": "Dr. Raka Sheohare",
        "city": "Raipur",
        "group": null,
        "photo": "/faculty/f_raka_sheohare.jpg"
       },
       {
        "time": "11:50AM - 12:05PM",
        "title": "The Brain in Diabetes\nCognitive Decline, Dementia and Prevention",
        "speaker": "Dr. Rakesh Sahay",
        "city": "Hyderabad",
        "group": null,
        "photo": "/faculty/f_rakesh_sahay.jpg"
       },
       {
        "time": "12:05PM - 12:20AM",
        "title": "Integrating Mental Health into Everyday Diabetes Practice",
        "speaker": "Dr. Lotika Purohit",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_lotika_purohit.jpg"
       },
       {
        "time": "12:20AM - 12:30PM",
        "title": "Panel Discussion",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "session",
      "title": "Infection & Diabetes",
      "time": "12:30PM - 01:35PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Kinjal Jain",
        "city": "Mumbai",
        "photo": "/faculty/f_kinjal_jain.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Vishal Vaidya",
        "city": "Mumbai",
        "photo": "/faculty/f_vishal_vaidya.jpg"
       }
      ],
      "talks": [
       {
        "time": "12:30PM - 12:45PM",
        "title": "GENIUS study- SGLT2i Associated GU Infections",
        "speaker": "Dr. N. K. Singh",
        "city": "Dhanbad",
        "group": null,
        "photo": "/faculty/f_n_k_singh.jpg"
       },
       {
        "time": "12:45PM - 01:00PM",
        "title": "Why People with Diabetes are More Susceptible to Infections?",
        "speaker": "Dr. K. P. Chandra",
        "city": "Lucknow",
        "group": null,
        "photo": "/faculty/f_k_p_chandra.jpg"
       },
       {
        "time": "01:00PM - 01:15PM",
        "title": "TB & DM - An approach in 2026",
        "speaker": "Dr. Tejas Kamat",
        "city": "Goa",
        "group": null,
        "photo": "/faculty/f_tejas_kamat.jpg"
       },
       {
        "time": "01:15PM - 01:30PM",
        "title": "Preventing Hospitalisation: Early Recognition and Management of Serious Infection",
        "speaker": "Dr. Reshma Ghoderao",
        "city": "Nashik",
        "group": null,
        "photo": "/faculty/f_reshma_ghoderao.jpg"
       },
       {
        "time": "01:30PM - 01:35PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     },
     {
      "kind": "break",
      "time": "01:35PM - 02:30PM",
      "label": "Lunch"
     },
     {
      "kind": "session",
      "title": "Panel Discussion: Approach to Young T2DM - A Meaningful Chat",
      "time": "02:30PM - 03:00PM",
      "people": [
       {
        "role": "Moderator",
        "name": "Dr. Ami Sanghvi",
        "city": "Mumbai",
        "photo": "/faculty/f_ami_sanghvi.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Kirti Soota",
        "city": "New Delhi",
        "photo": "/faculty/f_kirti_soota.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Mikhil Kothari",
        "city": "Mumbai",
        "photo": "/faculty/f_mikhil_kothari.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Pranjali Shah",
        "city": "Mumbai",
        "photo": "/faculty/f_pranjali_shah.jpg"
       },
       {
        "role": "Panel",
        "name": "Dr. Kshitij Kumar",
        "city": "New Delhi",
        "photo": "/faculty/f_kshitij_kumar.jpg"
       }
      ],
      "talks": [],
      "type": "Panel"
     },
     {
      "kind": "session",
      "title": "What the Future Holds?",
      "time": "03:00PM - 04:15PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. Pulkit Kedia",
        "city": "Mumbai",
        "photo": "/faculty/f_pulkit_kedia.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Kulin Shah",
        "city": "Mumbai",
        "photo": null
       }
      ],
      "talks": [
       {
        "time": "03:00PM - 03:15PM",
        "title": "Orforglipron",
        "speaker": "Dr. Nikhil Nashikar",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_nikhil_nashikar.jpg"
       },
       {
        "time": "03:15PM - 03:30PM",
        "title": "ICOSEMA",
        "speaker": "Dr. Aparna Methil",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_aparna_methil.jpg"
       },
       {
        "time": "03:30PM - 03:45PM",
        "title": "Retatrutide",
        "speaker": "Dr. Balaji Chidambaram",
        "city": "Chennai",
        "group": null,
        "photo": "/faculty/f_balaji_chidambaram.jpg"
       },
       {
        "time": "03:45PM - 04:00PM",
        "title": "Implantable long lasting sensors- Future of CGM",
        "speaker": "Dr. Abhijit Jadhav",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_abhijit_jadhav.jpg"
       },
       {
        "time": "04:00PM - 04:15PM",
        "title": "Q&A",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "04:00PM - 04:30PM",
        "title": "Valedictory in DRS Hall",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Session"
     }
    ],
    "sessionCount": 5
   },
   {
    "hall": "RAHEJA HALL",
    "items": [
     {
      "kind": "break",
      "time": "08:30AM Onwards",
      "label": "Registration & Breakfast"
     },
     {
      "kind": "session",
      "title": "Oral Paper Presentations (07mins presentation + 02mins Discussion)",
      "time": "09:30AM - 10:30AM",
      "people": [
       {
        "role": "Judge",
        "name": "Dr. Sandeep Rai",
        "city": "Mumbai",
        "photo": "/faculty/f_sandeep_rai.jpg"
       },
       {
        "role": "Judge",
        "name": "Dr. Rakesh Sahay",
        "city": "Hyderabad",
        "photo": "/faculty/f_rakesh_sahay.jpg"
       }
      ],
      "talks": [
       {
        "time": "09:00AM - 09:09AM",
        "title": "Proflo-U®: A Quantitative Point-Of-Care Urine Albumin-To-Creatinine Ratio Platform For Early Detection Of Diabetic Kidney Disease—Analytical Agreement With Laboratory Methods And Clinical Validation",
        "speaker": "Dr. Aseem Mishra",
        "city": "Bhubaneswar",
        "group": null,
        "photo": null
       },
       {
        "time": "09:09AM - 09:18AM",
        "title": "Attenuated Total Reflectance-Fourier Transform Infrared (Atr-Ftir) Spectroscopic Profiling Of Urine In Diabetic States Among Adults Aged 18-59 In Metro Manila, Philippines: A Cross-Sectional Study",
        "speaker": "Dr. Kamala Angela Tingson",
        "city": "Philippines",
        "group": null,
        "photo": null
       },
       {
        "time": "09:18AM - 09:27AM",
        "title": "Distinct Glycaemic Signatures Predict Medication Response And Complication Risk In Diabetes: A Multicentre CGM Analysis",
        "speaker": "Dr. Shubhashree Patil",
        "city": "Mumbai",
        "group": null,
        "photo": "/faculty/f_shubhashree_patil.jpg"
       },
       {
        "time": "09:27AM - 09:36AM",
        "title": "Hemiballismus Secondary To Hyperglycaemia: A Rare Reversible Neurological Manifestation Of Diabetes",
        "speaker": "Dr. Triasha Dutta",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "09:36AM - 09:45AM",
        "title": "Glycemic Outcomes With Vildagliptin Xr Across Diabetes Duration In Indian Young-Onset T2Dm: Novelty Insights",
        "speaker": "Dr. Avais Pathan",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "09:45AM - 09:54AM",
        "title": "The Effect of Dapagliflozin on Cardiac Biomarkers and Cardiac Remodelling in Patients of Heart Failure and Diabetes Mellitus",
        "speaker": "Dr. Abhijay Aspathi",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "09:54AM - 10:03AM",
        "title": "Prescribing Patterns And Perceived Effectiveness Of Sglt2I/Dpp4I Fixed-Dose Combinations In T2Dm: A Survey Among Indian Clinicians",
        "speaker": "Dr. Subhash Sonawala",
        "city": "Mumbai",
        "group": null,
        "photo": null
       },
       {
        "time": "10:03AM - 10:30AM",
        "title": "Session wrap-up",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Papers"
     },
     {
      "kind": "session",
      "title": "Medical Writing & Publications Workshop",
      "time": "10:30AM - 11:30AM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr. K. Vijay Kumar",
        "city": "Bengaluru",
        "photo": "/faculty/f_k_vijay_kumar.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Jayesh Thaddani",
        "city": "Mumbai",
        "photo": "/faculty/f_jayesh_thaddani.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Shambo Samrat Samajdar",
        "city": "Kolkata",
        "photo": "/faculty/f_shambo_samrat_samajdar.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Ritu Johari",
        "city": "Mumbai",
        "photo": "/faculty/f_ritu_johari.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Punit Srivastava",
        "city": "Gurgaon",
        "photo": "/faculty/f_punit_srivastava.jpg"
       }
      ],
      "talks": [],
      "type": "Workshop"
     },
     {
      "kind": "session",
      "title": "The Role of Advanced Diabetes Specific Nutrition- A Workshop on the Continuum",
      "time": "11:30AM - 12:30PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dt. Aanam Shaikh",
        "city": "Mumbai",
        "photo": "/faculty/f_aanam_shaikh.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dt. Nikita Jain",
        "city": "Mumbai",
        "photo": "/faculty/f_nikita_jain.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Shalini Jaggi",
        "city": "New Delhi",
        "photo": "/faculty/f_shalini_jaggi.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Piyush Desai",
        "city": "Surat",
        "photo": "/faculty/f_piyush_desai.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dt. Veena Pai",
        "city": "Mumbai",
        "photo": "/faculty/f_veena_pai.jpg"
       }
      ],
      "talks": [],
      "type": "Workshop"
     },
     {
      "kind": "session",
      "title": "BCA workshop",
      "time": "12:30PM - 02:00PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dt. Ami Shah",
        "city": "Mumbai",
        "photo": "/faculty/f_ami_shah.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Ms. Nandita Murthy",
        "city": "Mumbai",
        "photo": null
       },
       {
        "role": "Chairperson",
        "name": "Dr. Rakesh Parikh",
        "city": "Jaipur",
        "photo": "/faculty/f_rakesh_parikh.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Kavita Gupta",
        "city": "Nagpur",
        "photo": "/faculty/f_kavita_gupta.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dt. Sheryl Salis",
        "city": "Mumbai",
        "photo": "/faculty/f_sheryl_salis.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Prashant Salvi",
        "city": "Mumbai",
        "photo": "/faculty/f_prashant_salvi.jpg"
       }
      ],
      "talks": [],
      "type": "Workshop"
     },
     {
      "kind": "break",
      "time": "02:00PM - 02:30PM",
      "label": "Lunch"
     },
     {
      "kind": "session",
      "title": "Inhospital Hyperglycemia Workshop",
      "time": "02:30PM - 04:00PM",
      "people": [
       {
        "role": "Chairperson",
        "name": "Dr Yuti Sheth",
        "city": "",
        "photo": null
       },
       {
        "role": "Chairperson",
        "name": "TBD",
        "city": "",
        "photo": null
       },
       {
        "role": "Chairperson",
        "name": "Dr. Rahul Baxi",
        "city": "Mumbai",
        "photo": "/faculty/f_rahul_baxi.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Karthik Munichoodappa",
        "city": "Bengaluru",
        "photo": "/faculty/f_karthik_munichoodappa.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Reema Kashiva",
        "city": "Pune",
        "photo": "/faculty/f_reema_kashiva.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Nadia Phirozmand",
        "city": "Mumbai",
        "photo": "/faculty/f_nadia_phirozmand.jpg"
       },
       {
        "role": "Chairperson",
        "name": "Dr. Kamlesh Nayak",
        "city": "Mumbai",
        "photo": "/faculty/f_kamlesh_nayak.jpg"
       }
      ],
      "talks": [
       {
        "time": "04:00PM - 04:30PM",
        "title": "Valedictory in DRS Hall",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       },
       {
        "time": "",
        "title": "Synthetic Oral Sema- Obeda study",
        "speaker": "",
        "city": "",
        "group": null,
        "sublabel": true
       }
      ],
      "type": "Workshop"
     }
    ],
    "sessionCount": 5
   }
  ]
 }
];

export const programMeta = {"faculty": 252, "halls": ["DRS HALL", "IDF HALL", "RAHEJA HALL"], "dates": "04 – 06 September 2026", "venue": "Hotel Fairmont, Mumbai"};
